import { ActionSet, createActionSet } from '@futrli/shared-services';

import { FORGOT_PASSWORD_SENT_ROUTE } from '../core/constants';

export const FORGOT_PASSWORD: ActionSet = createActionSet('FORGOT_PASSWORD');

export const FORGOT_PASSWORD_SENT_PATH = FORGOT_PASSWORD_SENT_ROUTE;
